import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ColorButton from './buttons/ColorButton';
import SidePanel from './SidePanel';
import { COLOR_TOOLBAR } from '../constants/colors';

const ColorWrapDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
`;

const SidePanelColor = ({ currentColorKey, onSelectColorOption, onClose }) => (
  <SidePanel title="Color" showCloseButton onClose={onClose}>
    <ColorWrapDiv>
      {COLOR_TOOLBAR.map((option) => (
        <ColorButton
          key={option.key}
          selected={option.key === currentColorKey}
          rgb={option.rgb}
          onClick={() => {
            onSelectColorOption(option);
            onClose();
          }}
        />
      ))}
    </ColorWrapDiv>
  </SidePanel>
);

SidePanelColor.propTypes = {
  currentColorKey: PropTypes.string.isRequired,
  onSelectColorOption: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SidePanelColor;
